<template>
  <a target="_blank" href="https://www.instagram.com/bbva_argentina/">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="26"
      height="26"
      viewBox="0 0 26 26"
    >
      <defs>
        <path
          id="a-instagram"
          d="M1 13C1 6.373 6.373 1 13 1s12 5.373 12 12-5.373 12-12 12S1 19.627 1 13zm19.455 3.092c.036-.8.045-1.055.045-3.092s-.009-2.292-.045-3.092c-.037-.798-.163-1.344-.349-1.82a3.676 3.676 0 0 0-.865-1.33 3.676 3.676 0 0 0-1.328-.864c-.477-.186-1.022-.312-1.82-.349-.8-.036-1.056-.045-3.093-.045s-2.292.009-3.092.045c-.799.037-1.344.163-1.82.349a3.677 3.677 0 0 0-1.33.865 3.675 3.675 0 0 0-.864 1.328c-.186.477-.312 1.023-.349 1.82-.036.8-.045 1.056-.045 3.093s.009 2.292.045 3.092c.037.799.163 1.344.349 1.82.191.494.448.912.865 1.33.417.416.835.673 1.328.864.477.186 1.022.312 1.82.349.8.036 1.056.045 3.093.045s2.292-.009 3.092-.045c.799-.037 1.344-.163 1.82-.349a3.676 3.676 0 0 0 1.33-.865c.416-.417.673-.835.864-1.328.186-.477.312-1.022.349-1.82zm-1.608-7.515c.102.264.225.661.258 1.392.036.791.044 1.028.044 3.031s-.008 2.24-.044 3.03c-.033.732-.156 1.13-.258 1.393-.136.35-.299.6-.561.863a2.323 2.323 0 0 1-.863.56c-.264.103-.661.226-1.392.259-.791.036-1.028.044-3.031.044s-2.24-.008-3.03-.044c-.732-.033-1.129-.156-1.393-.258-.35-.136-.6-.299-.863-.561a2.325 2.325 0 0 1-.56-.863c-.103-.264-.226-.661-.259-1.392-.036-.791-.044-1.028-.044-3.031s.008-2.24.044-3.03c.033-.732.156-1.129.258-1.393.136-.35.299-.6.561-.863.263-.262.513-.425.863-.56.264-.103.661-.226 1.392-.259.791-.036 1.028-.044 3.031-.044s2.24.008 3.03.044c.732.033 1.129.156 1.393.258.35.136.6.299.863.561.262.263.425.513.56.863zm-1.843 1.32a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8zM13 16.85a3.851 3.851 0 1 0 0-7.702 3.851 3.851 0 0 0 0 7.702z"
        />
      </defs>
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h26v26H0z" />
        <mask id="b-instagram" fill="#5BBEFF">
          <use xlink:href="#a-instagram" />
        </mask>
        <use class="hover--icon" fill="#5BBEFF" xlink:href="#a-instagram" />
        <g fill="#5BBEFF" mask="url(#b-instagram)">
          <path class="hover--icon" d="M0 0h26v26H0z" />
        </g>
      </g>
    </svg>
  </a>
</template>

<script>
export default {
  name: "InstagramImage"
};
</script>
<style scoped>
a:hover .hover--icon {
  fill: #fff;
}
</style>
